import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

interface LeaderboardListParams {
    page?: number;
    limit?: number;
    search?: string;
    deckId?: string;
    quizId?: string;
}

interface user {
    _id: string;
    full_name: string;
    email_address: string;
}

interface quiz {
    _id: string;
    type: string;
    question: string;
    correct_answer: string;
    term: string;
}

interface quizData {
    _id: string;  
    quiz: quiz
}

interface History {
    _id: string;
    userId: string;
    deckId: string;
    quizId: string;
    questionId: string;
    date_studied: string;
    createdAt: string;
    is_correct: boolean;
    review_score: number;
    correct_answer: string;
    user_answer: string;
    user: user[];
    quizData: quizData;
}

interface HistoryListResponse {
    histories: History[];
    count: number;
}

const BASE_URL = `/history`;

const HistoryService = {
    getHistoryByDeckId: (params?: LeaderboardListParams): Promise<AxiosResponse<HistoryListResponse>> => {
        return instanceAxios.get(`${BASE_URL}/getHistoryByDeckId`, {
            params: {
                page: params?.page ?? 1,
                limit: params?.limit ?? 10,

                deckId: params?.deckId ?? '',
            },
        });
    },
};

export default HistoryService;